import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {runPollEvents, stopPollEvents} from "../store/alerts/actions";


const useRunPollEvents = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(runPollEvents());

        return () => {
            dispatch(stopPollEvents())
        }
    }, [])
};

export default useRunPollEvents